import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useHostProfile } from '../../../contextProviders/HostProfileProvider';
import SettingsRow from '../../../components/Settings/SettingsRow';
import SettingsCard from '../../../components/Settings/SettingsCard';
import { useAppBreakpoint } from '../../../hooks/useAppBreakpoint';
import { TRANSLATIONS } from '../../../constants/translations';
import { translate } from '../../../helpers/translationHelper';

const { Title, Text } = Typography;

/** "Configuración > Impuestos" -- host-only (a guest has no tax identity to show here). */
const TaxSection: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useAppBreakpoint();
  const navigate = useNavigate();
  const { hostProfile, hasHostProfile } = useHostProfile();

  return (
    <div>
      {/* Redundant on mobile -- the list->detail header (Settings.tsx) already shows this section's name. */}
      {!isMobile && (
        <Title level={4} style={{ marginBottom: 20 }}>
          {translate(t, TRANSLATIONS.SETTINGS_NAV_TAXES)}
        </Title>
      )}

      {!hasHostProfile ? (
        <Text type="secondary">{translate(t, TRANSLATIONS.SETTINGS_TAXES_NOT_HOST)}</Text>
      ) : (
        <SettingsCard noMarginBottom>
          <SettingsRow
            label={translate(
              t,
              hostProfile?.accountType === 'Business' ? TRANSLATIONS.HOST_FIELD_TAX_ID_BUSINESS : TRANSLATIONS.HOST_FIELD_TAX_ID_INDIVIDUAL
            )}
            value={hostProfile?.taxId || '—'}
            actionLabel={translate(t, TRANSLATIONS.SETTINGS_EDIT_LINK)}
            onAction={() => navigate('/host/profile/edit/legal')}
          />
        </SettingsCard>
      )}

      <Title level={5} style={{ marginTop: 32, marginBottom: 8 }}>
        {translate(t, TRANSLATIONS.SETTINGS_TAXES_DOCUMENTS_TITLE)}
      </Title>
      <Text type="secondary">{translate(t, TRANSLATIONS.SETTINGS_TAXES_DOCUMENTS_PLACEHOLDER)}</Text>
    </div>
  );
};

export default TaxSection;
